export const categories = [
  { slug: 'mingxing-bagua', name: '明星八卦', icon: 'ri-star-line', description: '娱乐圈明星最新动态与绯闻爆料', count: 1280 },
  { slug: 'wanghong-dagua', name: '网红大瓜', icon: 'ri-live-line', description: '网红圈热门事件与争议话题追踪', count: 965 },
  { slug: 'zongyi-gaoxiao', name: '综艺搞笑', icon: 'ri-emotion-laugh-line', description: '综艺节目名场面与搞笑片段合集', count: 1523 },
  { slug: 'tafang-xianchang', name: '塌房现场', icon: 'ri-alert-line', description: '明星翻车事故与塌房名场面回顾', count: 732 },
  { slug: 'yingshi-jiexi', name: '影视解析', icon: 'ri-movie-2-line', description: '热播影视剧深度解析与幕后故事', count: 1089 },
  { slug: 'chigua-remen', name: '吃瓜热门', icon: 'ri-fire-line', description: '全网最热吃瓜内容实时聚合', count: 2105 },
];

export const articles = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，全程被拍画面曝光',
    slug: 'dingliu-nanxing-shenye-mihui',
    category: 'mingxing-bagua',
    categoryName: '明星八卦',
    excerpt: '近日，有媒体拍到某顶流男星深夜与一名神秘女子同回酒店，两人举止亲密，疑似恋情曝光。画面中该男星全副武装，但仍被认出。',
    content: '近日，娱乐圈又爆出一个重磅消息。据知情人士透露，某当红顶流男星在结束一天的拍摄工作后，并未直接返回住所，而是驱车前往市中心一家五星级酒店。不久后，一位身着黑色连衣裙的神秘女子出现在酒店大堂，两人在电梯间相遇后一同上楼。据目击者描述，两人在电梯内交谈甚欢，男星还主动接过女子手中的物品，举止颇为亲密。直到次日清晨，该男星才独自离开酒店，全程戴着口罩和帽子试图遮掩身份，但独特的穿搭风格还是被眼尖的粉丝认出。这一消息传出后，迅速在社交平台引发热议。该男星的粉丝群体出现两极分化，一部分表示"哥哥也是普通人，有恋爱自由"，另一部分则强烈要求工作室出面澄清。截至目前，该男星及其工作室均未对此事做出任何回应。业内人士分析认为，如果恋情属实，可能会对该男星接下来的代言和影视资源产生一定影响。据悉，该男星目前手握多个一线品牌代言，其中包含两个正在洽谈续约的国际大牌。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20paparazzi%20night%20scene%20outside%20luxury%20hotel%20entrance%20with%20dramatic%20lighting%20and%20red%20accents%2C%20mysterious%20silhouette%20figures%2C%20urban%20night%20atmosphere%2C%20minimalist%20editorial%20style%2C%20professional%20news%20photography%20aesthetic&width=800&height=500&seq=home-article-hot-01&orientation=landscape',
    views: 1285000,
    likes: 89200,
    comments: 23400,
    date: '2026-07-06',
    author: '吃瓜前线记者',
    tags: ['顶流', '恋情', '偷拍', '娱乐圈'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: true,
    isNew: true,
  },
  {
    id: '2',
    title: '网红直播带货翻车现场：声称"纯天然"产品被检测出违禁成分',
    slug: 'wanghong-zhibo-fanche',
    category: 'wanghong-dagua',
    categoryName: '网红大瓜',
    excerpt: '拥有千万粉丝的某头部网红在直播带货时，其主推的"纯天然草本"护肤品被第三方检测机构查出含有糖皮质激素，引发消费者集体维权。',
    content: '一场直播带货的翻车事故正在持续发酵。拥有超过1200万粉丝的某知名网红，在上周的直播中大力推荐一款号称"纯天然草本配方、孕妇可用"的护肤套装，短短两小时内销售额突破800万元。然而好景不长，一位购买该产品的消费者使用后出现面部红肿过敏症状，随即将产品送往第三方检测机构化验。检测结果令人震惊：该产品中含有丙酸氯倍他索——一种强效糖皮质激素，长期使用会导致激素依赖性皮炎、皮肤萎缩等严重问题。消息传出后，大批消费者在社交平台发起声讨，要求该网红和品牌方给出解释并赔偿。涉事网红第一时间发布道歉视频，泪洒直播间表示"自己也是被品牌方欺骗"，但网友并不买账，纷纷翻出其此前多次强调"亲自试用过、绝对安全"的直播片段。目前，市场监管部门已介入调查，涉事产品已被下架，品牌方的多个电商平台店铺也被关闭。法律人士表示，该网红作为广告代言人，若明知产品存在问题仍进行虚假宣传，可能需要承担连带赔偿责任。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20setup%20with%20beauty%20products%20on%20display%2C%20dramatic%20red%20alert%20theme%2C%20dark%20background%20with%20warning%20symbols%2C%20professional%20broadcast%20equipment%2C%20cinematic%20lighting%2C%20editorial%20style&width=800&height=500&seq=home-article-hot-02&orientation=landscape',
    views: 2360000,
    likes: 156000,
    comments: 45200,
    date: '2026-07-05',
    author: '消费维权观察员',
    tags: ['网红', '直播带货', '翻车', '维权'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    title: '某知名女星综艺录制现场情绪失控，现场导演紧急叫停',
    slug: 'nvxing-zongyi-qingxu-shikong',
    category: 'zongyi-gaoxiao',
    categoryName: '综艺搞笑',
    excerpt: '在某王牌综艺节目录制过程中，一位以温婉形象著称的女星突然情绪崩溃，泪洒录制现场，节目组不得不暂停录制进行安抚。',
    content: '娱乐圈又一起令人意外的事件发生在综艺录制现场。据现场观众爆料，在某卫视王牌综艺的最新一期录制中，一位以"仙女"人设走红的女星在游戏环节中突然情绪失控。据悉，事发时正在进行一个团队竞赛游戏，该女星所在的小组连续三轮落后。在最后一轮的关键环节中，同组另一位嘉宾的一句无心之言似乎触及了她的敏感点，该女星先是沉默，随后突然泪流满面，情绪激动地表示"自己已经尽力了"。现场气氛一度十分尴尬，主持人试图打圆场但效果不佳。最终，节目总导演不得不叫停录制，安排该女星到休息室调整情绪。约40分钟后，录制才得以继续。但据现场观众反映，后半程该女星的状态明显不佳，参与游戏的积极性也大不如前。事件曝光后，网友对此议论纷纷。有人表示理解艺人压力大，也有人质疑这是否是节目组设计的"剧本"。该女星工作室随后发文称"艺人近期工作强度较大，身体不适导致情绪波动，感谢大家的关心"。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Television%20variety%20show%20recording%20studio%20with%20colorful%20stage%20lights%20and%20dramatic%20atmosphere%2C%20dark%20background%20with%20contrasting%20bright%20spots%2C%20professional%20production%20environment%2C%20cinematic%20composition%2C%20editorial%20photography%20style&width=800&height=500&seq=home-article-hot-03&orientation=landscape',
    views: 985000,
    likes: 67200,
    comments: 31200,
    date: '2026-07-04',
    author: '综艺现场揭秘',
    tags: ['综艺', '女星', '情绪失控', '录制现场'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '爆！某选秀出道偶像被爆在恋爱期间同时交往多人，聊天记录实锤流出',
    slug: 'xuanxiu-ouxiang-duoren-lianai',
    category: 'tafang-xianchang',
    categoryName: '塌房现场',
    excerpt: '一位从选秀节目出道不到两年的新生代偶像，被多名女生联合爆料在恋爱期间同时与多人交往，大量聊天截图和转账记录被公开。',
    content: '一颗冉冉升起的新星正在经历出道以来最大的危机。从去年热门选秀节目中以第三名出道的某偶像艺人，近日被多名自称是其"女友"的女生联合爆料。据其中一位爆料者称，她与该偶像从去年10月开始交往，期间对方以"公司不允许公开恋情"为由要求保密。然而在今年3月，她意外发现有至少四位女生与她的经历几乎一模一样——同样的追求方式、同样的保密理由、甚至同样的甜言蜜语。更令人震惊的是，爆料者们公布的聊天记录显示，该偶像在去年12月31日跨年夜，竟然在三个小时内给三位不同的"女友"发送了几乎完全一致的新年祝福，连表情包都一模一样。此外，他还多次以"交房租""家人生病"等理由向多位女友借钱，累计金额超过50万元。此事迅速登上热搜榜首，该偶像所在的经纪公司紧急发表声明，称"正在核实相关情况，将依法追究造谣者责任"。但随着越来越多的证据被公开，事态显然已超出公司可控范围。多个品牌方已宣布暂停与该偶像的合作，其在播的综艺节目也被紧急打码处理。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20scandal%20visual%20with%20broken%20heart%20symbolism%2C%20dark%20red%20and%20black%20color%20palette%2C%20collapsed%20stage%20aesthetic%2C%20abstract%20minimalist%20design%2C%20high%20contrast%20dramatic%20lighting%2C%20editorial%20photography%20style&width=800&height=500&seq=home-article-hot-04&orientation=landscape',
    views: 3850000,
    likes: 267000,
    comments: 89100,
    date: '2026-07-03',
    author: '塌房记录员',
    tags: ['选秀', '偶像', '塌房', '多人恋爱'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: true,
    isNew: true,
  },
  {
    id: '5',
    title: '《延禧攻略》完整版在线观看指南：未删减版vs TV版对比解析',
    slug: 'yanxi-gonglue-wanzhengban',
    category: 'yingshi-jiexi',
    categoryName: '影视解析',
    excerpt: '深度解析《延禧攻略》完整版与TV版的差异，盘点那些被删减的精彩片段，以及在哪里可以观看到最完整的版本。',
    content: '《延禧攻略》作为近年来最受欢迎的清宫剧之一，不少观众可能不知道，电视上播出的版本与网络完整版存在不少差异。本文将为大家详细盘点。首先，在剧情方面，完整版比TV版多出了约120分钟的内容。这些被删减的片段主要集中在以下几个方面：一是魏璎珞与富察傅恒的感情线，TV版对其进行了大幅删减，导致两人的感情发展显得有些突兀；二是高贵妃的戏份，完整版中有更多展现其性格复杂面的情节。其次，在人物塑造上，完整版给予了配角更多的发挥空间。例如明玉与海兰察的感情线在完整版中有完整的起承转合，而TV版几乎一笔带过。纯妃的黑化过程在完整版中也更为细腻和合理。对于想要观看《延禧攻略》完整版的观众，目前爱奇艺平台提供了最完整的版本，包含70集内容，而TV版仅有57集。此外，YouTube上也有官方上传的完整版资源可供观看。建议想深入了解剧情细节的观众选择完整版进行观看。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20palace%20drama%20aesthetic%20with%20vintage%20royal%20court%20elements%2C%20dark%20dramatic%20background%20with%20gold%20accents%2C%20traditional%20Chinese%20architecture%20details%2C%20cinematic%20composition%2C%20editorial%20photography%20style&width=800&height=500&seq=home-article-cat-01&orientation=landscape',
    views: 756000,
    likes: 45200,
    comments: 18900,
    date: '2026-07-02',
    author: '影视深度解析',
    tags: ['延禧攻略', '完整版', '影视解析', '清宫剧'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: false,
    isNew: false,
  },
  {
    id: '6',
    title: '某知名导演被曝片场霸凌演员，多位艺人站出来力证',
    slug: 'daoyan-pianchang-baling',
    category: 'mingxing-bagua',
    categoryName: '明星八卦',
    excerpt: '一位曾获国际大奖的知名导演被爆在片场对演员进行言语和行为上的霸凌，多位与其合作过的演员纷纷站出来讲述自己的经历。',
    content: '电影圈再爆猛料。一位在国际上享有盛誉的知名导演，近日被多位合作过的演员联合指控在片场存在霸凌行为。第一位站出来发声的是曾与这位导演合作过两部电影的女演员A。她在社交媒体上发长文，详细描述了在拍摄期间遭受的种种不公待遇：导演曾当众辱骂她的演技"连群演都不如"，在她NG超过五次后直接把剧本摔在她脸上，还曾在寒冬天要求她连续在水中浸泡四个小时拍摄一个仅有三秒的镜头。随后，更多的演员加入声援行列。男演员B透露，该导演偏爱使用"激将法"，曾在拍摄现场连续数小时对一个新人演员进行人格羞辱，导致该演员当场崩溃大哭。女演员C则表示，导演对她进行过不恰当的肢体接触，包括在指导动作戏时借机触碰私密部位。面对越来越多的指控，该导演通过律师发表声明，否认一切指控，称这些是"恶意诽谤和有组织的网络暴力"。然而，越来越多的业内人士相信这些指控并非空穴来风。中国电影导演协会表示将对此事进行调查。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20film%20set%20atmosphere%20with%20professional%20movie%20camera%20and%20director%20chair%20silhouette%2C%20dramatic%20contrast%20lighting%2C%20empty%20sound%20stage%2C%20tense%20mood%2C%20minimalist%20cinematic%20composition%2C%20editorial%20photography%20style&width=800&height=500&seq=home-article-cat-02&orientation=landscape',
    views: 1680000,
    likes: 124000,
    comments: 56300,
    date: '2026-07-01',
    author: '娱乐圈内幕',
    tags: ['导演', '霸凌', '片场', '演员'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: true,
    isNew: false,
  },
  {
    id: '7',
    title: '双胞胎网红姐妹花翻车：假扮穷人博同情，实际开豪车住别墅',
    slug: 'shuangbaotai-jiaqiong-botongqing',
    category: 'wanghong-dagua',
    categoryName: '网红大瓜',
    excerpt: '一对以"农村贫困姐妹花"人设走红的双胞胎网红，被网友扒出实际家境优渥，视频中的"贫困生活"全是精心策划的剧本。',
    content: '又一对网红人设彻底崩塌。拥有800万粉丝的"小芳小丽"双胞胎姐妹花，一直以"来自偏远山区、父母双亡、靠打工供自己上学"的苦情形象示人，感动了无数网友，直播间打赏和带货收入颇丰。然而，一位自称是她们高中同学的网友的爆料，彻底撕下了这层伪装。据该网友透露，这对姐妹花实际上出身于一个相当富裕的家庭，父亲是当地一家建筑公司的老板，母亲是中学教师。她们从小就读私立学校，高中时就已经背着名牌包上学。更让粉丝愤怒的是，有网友扒出了姐妹花名下的资产：两人名下各有一辆价值百万的豪车，而且还共同持有一套市中心的豪华别墅。这与视频中她们"住漏雨土房、吃馒头咸菜"的形象形成鲜明对比。此事曝光后，"小芳小丽"的社交账号一夜之间掉粉超过200万。姐妹花随后发布道歉视频，声泪俱下地表示"只是想通过这种方式让更多人关注留守儿童的困境"，但这样的解释显然无法让愤怒的粉丝满意。目前，多个与其合作的品牌方已宣布解约。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Contrasting%20visual%20of%20luxury%20villa%20versus%20rural%20poverty%20split%20screen%20style%2C%20dramatic%20social%20commentary%2C%20dark%20red%20and%20gold%20accents%2C%20abstract%20editorial%20design%2C%20cinematic%20composition%2C%20high%20contrast%20lighting&width=800&height=500&seq=home-article-trend-01&orientation=landscape',
    views: 4210000,
    likes: 312000,
    comments: 128000,
    date: '2026-06-30',
    author: '网红打假联盟',
    tags: ['网红', '双胞胎', '翻车', '虚假人设'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: true,
    isNew: true,
  },
  {
    id: '8',
    title: '年度最搞笑综艺名场面合集：笑到肚子疼系列',
    slug: 'zongyi-mingmingchang-niandu',
    category: 'zongyi-gaoxiao',
    categoryName: '综艺搞笑',
    excerpt: '盘点2026上半年各大综艺节目中最令人捧腹大笑的经典名场面，每一个都值得反复回看。',
    content: '2026年已经过半，各大综艺节目为我们贡献了无数欢乐时刻。今天就来盘点那些笑到停不下来的综艺名场面。排名第一的当属《奔跑吧》中，一位以机智著称的男嘉宾在"你画我猜"环节中，把"奥特曼"画成了一个长了眼睛的土豆，让全场嘉宾笑到直不起腰。更搞笑的是，他的队友竟然猜了三次才终于答对。《向往的生活》中，一位从不做饭的女星第一次下厨，把糖当成盐放进了红烧肉里，结果吃了一口后表情管理完全失控，但为了不打击她的信心，其他嘉宾硬是把整盘甜味红烧肉吃完了，场面既好笑又暖心。《密室大逃脱》最新季中，一位以"胆大"闻名的男嘉宾在遇到NPC吓人时，吓得直接跳到另一位嘉宾身上，两人双双摔倒在地，这一幕被网友疯狂截图做成表情包，成为年度最热门表情包之一。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20studio%20with%20comedic%20atmosphere%2C%20bright%20stage%20lights%20and%20confetti%2C%20playful%20energy%2C%20dark%20background%20with%20vibrant%20color%20pops%2C%20cinematic%20wide%20shot%2C%20editorial%20photography&width=800&height=500&seq=home-article-trend-02&orientation=landscape',
    views: 890000,
    likes: 67200,
    comments: 23400,
    date: '2026-06-29',
    author: '综艺笑点收割机',
    tags: ['综艺', '名场面', '搞笑', '合集'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: false,
    isNew: false,
  },
  {
    id: '9',
    title: '某男团队内不和实锤：演出后台大打出手，经纪人劝架被误伤',
    slug: 'nantuan-neibubuhe-shichui',
    category: 'tafang-xianchang',
    categoryName: '塌房现场',
    excerpt: '一支当红男子偶像团体在某音乐节后台爆发激烈冲突，两名成员从口头争执升级为肢体冲突，场面一度失控。',
    content: '偶像团体的光鲜外表下，暗流涌动。据现场工作人员爆料，一支拥有超高人气的五人男子偶像团体，在上周末某大型音乐节的演出后台，发生了严重的内部冲突。据知情人士描述，冲突的导火索是演出站位问题。成员A认为自己在最新单曲中的镜头和歌词分配太少，在演出前向队长和经纪人表达了不满。而成员B（据传是公司力捧的对象）对此嗤之以鼻，嘲讽道"能力不行就别怪分配少"。这句话彻底点燃了矛盾。成员A冲上前推搡了成员B，两人随即扭打在一起。其他成员和工作人员试图拉开两人，过程中一名经纪人被误伤，手臂出现明显瘀青。混乱持续了大约五分钟才被控制住。令人意外的是，事发仅仅半小时后，五人就面带微笑地登上舞台完成了演出，展现出了"完美的团队默契"。这种表里不一的表现让事后得知真相的粉丝既震惊又失望。目前，该团体的经纪公司已出面道歉，称会加强内部管理，但并未透露是否会对涉事成员做出处理。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20backstage%20confrontation%20scene%20with%20dramatic%20red%20lighting%2C%20music%20concert%20equipment%20in%20background%2C%20tense%20atmosphere%2C%20abstract%20conflict%20visualization%2C%20dark%20cinematic%20mood%2C%20editorial%20photography%20style&width=800&height=500&seq=home-article-trend-03&orientation=landscape',
    views: 2920000,
    likes: 201000,
    comments: 78500,
    date: '2026-06-28',
    author: '娱乐圈前线',
    tags: ['男团', '内讧', '后台', '打架'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: true,
    isNew: false,
  },
  {
    id: '10',
    title: '《狂飙》续集正式官宣！原班人马回归还是全新阵容？',
    slug: 'kuangbiao-xuji-xuanbu',
    category: 'yingshi-jiexi',
    categoryName: '影视解析',
    excerpt: '热播剧《狂飙》续集正式宣布启动制作，关于演员阵容、剧情走向的各种猜测引发网友热议。',
    content: '让无数观众翘首以盼的消息终于来了。《狂飙》官方今日正式宣布续集启动制作，这一消息瞬间点燃了社交媒体。据官方发布的公告显示，续集暂定名为《狂飙2：暗流》，故事时间线将设定在第一部结局的三年之后。高启强伏法后，京海市看似恢复了平静，但新的犯罪势力正在暗处悄然滋生。安欣将面临全新的挑战，与新一代犯罪分子展开智慧与勇气的较量。关于演员阵容，官方表示"正在积极协调原班人马回归"，但并未给出明确承诺。据业内消息，张译和张颂文两位主演的回归谈判正在进行中，但档期和片酬是主要障碍。有传闻称，如果原班人马无法全员回归，制作方可能会采用"新老结合"的方式，引入实力派新演员加入。此外，续集的制作规模将全面升级。据悉，制作预算比第一部提高了约60%，拍摄周期预计长达8个月。导演徐纪周将继续执导，他表示"续集的故事会更加烧脑，角色的命运会更加曲折"。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crime%20drama%20TV%20series%20promotional%20aesthetic%20with%20dark%20urban%20cityscape%20and%20police%20theme%2C%20dramatic%20lighting%20with%20blue%20and%20red%20contrast%2C%20intense%20thriller%20mood%2C%20cinematic%20composition%2C%20editorial%20photography%20style&width=800&height=500&seq=home-article-cat-03&orientation=landscape',
    views: 1120000,
    likes: 89200,
    comments: 35600,
    date: '2026-06-27',
    author: '影视情报站',
    tags: ['狂飙', '续集', '官宣', '张译', '张颂文'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: true,
    isNew: false,
  },
  {
    id: '11',
    title: '某女星被拍到深夜出入整形医院，全脸精致调整前后对比惊人',
    slug: 'nvxing-zhengxing-yiyuan',
    category: 'mingxing-bagua',
    categoryName: '明星八卦',
    excerpt: '一位以"天然美女"著称的女星被拍到深夜出入知名整形医院，网友扒出其近年来的面部变化对比图，变化之大令人咋舌。',
    content: '娱乐圈的"天然美女"标签又一次遭到质疑。近日，有媒体拍到一位以"母胎美女"闻名的女星深夜从某知名整形医院后门匆匆离开，全程低头玩手机，身边还有助理帮忙遮挡。虽然该女星迅速上车离开，但还是被拍到了清晰的正脸照片。更"实锤"的是，有网友扒出了该医院的价格表，其中一项"全脸精雕"项目与她之前在采访中提到的"做了个小调整"在时间上完美吻合。整形分析师对这位女星近三年来的照片进行了详细对比分析，发现其面部至少有以下变化：双眼皮从内双变成了明显的开扇形；鼻梁高度明显提升，鼻尖变得更加精致；下巴形状由圆润变为尖翘；面部轮廓整体变得更加立体。分析指出，这些变化不太可能是"化妆效果"或"长开了"能解释的。该女星的粉丝对此反应强烈，有人表示"爱美之心人皆有之"，也有人表示"一直标榜自己是纯天然，这才是最让人失望的"。截至目前，该女星及其工作室尚未对此事做出任何回应。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20medical%20aesthetic%20clinic%20exterior%20at%20night%20with%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20dark%20ambient%20lighting%2C%20dramatic%20shadows%2C%20editorial%20composition%2C%20high%20contrast%20scene&width=800&height=500&seq=home-article-cat-04&orientation=landscape',
    views: 1350000,
    likes: 98700,
    comments: 45600,
    date: '2026-06-26',
    author: '整形鉴定师',
    tags: ['女星', '整形', '对比', '天然美女'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    title: '直播界"一哥"涉嫌偷税漏税被调查，补缴金额或创行业新高',
    slug: 'zhibo-yige-toushui',
    category: 'wanghong-dagua',
    categoryName: '网红大瓜',
    excerpt: '直播带货界的头部主播"一哥"被税务部门约谈，涉嫌通过阴阳合同等方式偷逃巨额税款，据传补缴金额可能超过十亿元。',
    content: '直播带货行业再次迎来税务风暴。据权威消息透露，被誉为直播界"一哥"的某超级头部主播，近日已被税务部门正式立案调查。据了解，该主播在过去三年间，通过"阴阳合同"、虚假申报、转移收入至关联空壳公司等多种手段，涉嫌偷逃个人所得税及增值税共计超过8亿元。税务部门在对其关联的数十家公司进行穿透式审查后，发现了大量资金回流异常的情况。有知情人士透露，该主播的税务问题比此前报道的更加严重。除了个人收入外，其控制的MCN机构也存在大量不规范操作，包括虚构成本、虚开发票、以"坑位费"名义收取品牌方款项后不入账等。如果所有问题被查实，补缴税款加罚款的总金额可能超过15亿元，将创下直播行业税务处罚的新纪录。事发后，该主播的所有直播活动已暂停，多个品牌方紧急下架了与其相关的宣传物料。税务专家表示，随着金税四期系统的上线，过去的一些"避税"手段已经无处遁形，直播行业将迎来一轮前所未有的税务合规浪潮。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Financial%20investigation%20visual%20with%20tax%20documents%20and%20digital%20wealth%20symbolism%2C%20dark%20corporate%20atmosphere%2C%20red%20warning%20elements%2C%20minimalist%20abstract%20design%2C%20editorial%20photography%20style%2C%20high%20contrast%20lighting&width=800&height=500&seq=home-article-trend-04&orientation=landscape',
    views: 5100000,
    likes: 389000,
    comments: 156000,
    date: '2026-06-25',
    author: '财经观察室',
    tags: ['直播', '偷税', '一哥', '调查'],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    isHot: true,
    isNew: true,
  },
];

export const testimonials = [
  {
    name: '吃瓜小能手',
    role: '资深瓜友',
    rating: 5,
    content: '每天必刷的网站！消息更新速度太快了，比微博还快半拍。已经推荐给身边所有爱八卦的朋友了。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20young%20Asian%20woman%20with%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting%2C%20casual%20style%2C%20high%20quality%20photography&width=80&height=80&seq=avatar-user-01&orientation=squarish',
  },
  {
    name: '娱乐圈观察家',
    role: '自媒体博主',
    rating: 5,
    content: '做自媒体三年了，吃瓜视频网是我最重要的信息来源之一。爆料真实度高，而且整理得很清晰，省去了大量筛选信息的时间。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Asian%20man%20with%20confident%20expression%2C%20modern%20casual%20attire%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20high%20quality%20headshot%20photography&width=80&height=80&seq=avatar-user-02&orientation=squarish',
  },
  {
    name: '追星少女小美',
    role: '忠实用户',
    rating: 5,
    content: '页面设计很舒服，刷起来停不下来！分类也很清晰，想看明星八卦还是网红大瓜都能快速找到。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20girl%20with%20bright%20smile%20and%20trendy%20style%2C%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression%2C%20high%20quality%20photography&width=80&height=80&seq=avatar-user-03&orientation=squarish',
  },
  {
    name: '理性吃瓜人',
    role: '法律从业者',
    rating: 4,
    content: '相比其他八卦平台，这里的报道相对克制，不会过度渲染。希望能坚持这种风格，在娱乐和法律边界上找好平衡。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20in%20business%20attire%20with%20serious%20but%20friendly%20expression%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20corporate%20headshot%20style&width=80&height=80&seq=avatar-user-04&orientation=squarish',
  },
  {
    name: '资深剧迷',
    role: '影视爱好者',
    rating: 5,
    content: '影视解析板块做得特别棒！延禧攻略完整版的分析让我找到了好多之前没注意到的细节。希望多做这类深度内容。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20woman%20with%20creative%20artistic%20style%2C%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20high%20quality%20photography%2C%20casual%20vibe&width=80&height=80&seq=avatar-user-05&orientation=squarish',
  },
  {
    name: '吃瓜路人甲',
    role: '普通网友',
    rating: 5,
    content: '朋友推荐的，一开始还担心是标题党，用了之后发现内容质量确实高。现在每天中午休息时间都在刷。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20person%20with%20neutral%20friendly%20expression%2C%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20everyday%20casual%20style%2C%20high%20quality%20photography&width=80&height=80&seq=avatar-user-06&orientation=squarish',
  },
];